'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const ContactDealerFavorite = require('./ContactDealerFavorite');
const { variants } = require('../../constants/maytestConstants.es');

function ContactDealerMessageSent({company, favoriteDealer, favoriteDealerCta, pk, uri, type, maytest}) {
    return (
        <div className="pdp-dealer-section pdp-contact-dealer">
            <h1 className="pdp-contact-dealer-title">Your message was sent!</h1>
            <p className="pdp-contact-description">
                {maytest === variants.CONTACT2 ? `The ${type} will respond to your message shortly` :
                    `Follow ${company} to receive weekly email alerts when they add new listings on 1stdibs`
                }
            </p>
            {maytest !== variants.CONTACT2 &&
                <ContactDealerFavorite
                    company={company}
                    favoriteDealer={favoriteDealer}
                    favoriteDealerCta={favoriteDealerCta}
                    pk={pk}
                    uri={uri}
                />
            }
        </div>
    );
}

ContactDealerMessageSent.propTypes = {
    company: PropTypes.string.isRequired,
    favoriteDealer: PropTypes.object.isRequired,
    favoriteDealerCta: PropTypes.object.isRequired,
    pk: PropTypes.string.isRequired,
    uri: PropTypes.string.isRequired,
    type: PropTypes.string,
    maytest: PropTypes.string
};

module.exports = ContactDealerMessageSent;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/ContactDealer/ContactDealerMessageSent.jsx